import { InfoSvg } from "./InfoSVG";
export default InfoSvg;
